import t from"styled-components";import{theme as o}from"../../../../../theme.js";const i=({success:e=!1,error:r=!1})=>e?"#00C853":r?"#EA3100":"#CBD5E1",s=t.div`
  background-color: ${o.colors.gray[50]};
  border-radius: 6px;
  border: 1px dashed ${({success:e,error:r})=>i({success:e,error:r})};
  height: 300px;
  position: relative;
  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  label {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .placeholder {
    display: flex;
    align-items: center;
    color: ${o.colors.secondary[900]};
    svg {
      width: 30px;
      height: 30px;
      opacity: .54;
      margin-right: ${o.spacing*2}px;
    }
    p, h3 {
      margin: 0;
    }
    h3 {
      font-size: 16px;
    }
    p {
      color: ${o.colors.primary[500]};
      text-decoration: underline;
      font-size: 12px;
      font-weight: bold;
    }
  }
  .preview {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      width: 100%;
      height: auto;
      object-fit: contain;
      max-height: 298px;
      border-radius: 6px;
    }
    button {
      position: absolute;
      top: 8px;
      right: 8px;
      background-color: ${o.colors.shades[0]};
      border-radius: 50%;
      width: 25px;
      height: 25px;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: ${o.boxShadow};
      > svg {
        width: 20px;
        height: 20px;
        > g, path {
          fill: ${o.colors.gray[900]}
        }
      }
      &:hover {
        background-color: ${o.colors.gray[50]};
      }
    }
  }
`;export{s as Container};
